import { AsmAssetsViewId } from '../models/asm-assets-view-id';
import { AsmAssetsType } from '../models/asm-assets-type';
import { SolTag, SolText, SolType, SolViewId, TypeService, ViewService } from '@sol/components';

export function provideAsmAssetsViews(viewService: ViewService, typeService: TypeService): void {
  typeService.addType(AsmAssetsType.hostTechnologyLabel);
  typeService.addType(AsmAssetsType.domainTechnologyLabel);
  typeService.addType(AsmAssetsType.websiteTechnologyLabel);
  viewService.addView(
    AsmAssetsType.hostTechnologyLabel,
    'edit',
    AsmAssetsViewId.hostTechnologyLabelEdit,
    () =>
      import('../components/view/asm-view-edit-host-technology-label/asm-view-edit-host-technology-label.component').then(
        m => m.AsmViewEditHostTechnologyLabelComponent,
      ),
    true,
  );
  viewService.addView(
    AsmAssetsType.hostTechnologyLabel.array,
    'edit',
    AsmAssetsViewId.hostTechnologyLabelEdit,
    () =>
      import('../components/view/asm-view-edit-host-technology-label/asm-view-edit-host-technology-label.component').then(
        m => m.AsmViewEditHostTechnologyLabelComponent,
      ),
    true,
  );
  viewService.addView(
    AsmAssetsType.domainTechnologyLabel,
    'edit',
    AsmAssetsViewId.domainTechnologyLabelEdit,
    () =>
      import('../components/view/asm-view-edit-domain-technology-label/asm-view-edit-domain-technology-label.component').then(
        m => m.AsmViewEditDomainTechnologyLabelComponent,
      ),
    true,
  );
  viewService.addView(
    AsmAssetsType.domainTechnologyLabel.array,
    'edit',
    AsmAssetsViewId.domainTechnologyLabelEdit,
    () =>
      import('../components/view/asm-view-edit-domain-technology-label/asm-view-edit-domain-technology-label.component').then(
        m => m.AsmViewEditDomainTechnologyLabelComponent,
      ),
    true,
  );
  viewService.addView(
    AsmAssetsType.websiteTechnologyLabel,
    'edit',
    AsmAssetsViewId.websiteTechnologyLabelEdit,
    () =>
      import('../components/view/asm-view-edit-website-technology-label/asm-view-edit-website-technology-label.component').then(
        m => m.AsmViewEditWebsiteTechnologyLabelComponent,
      ),
    true,
  );
  viewService.addView(
    AsmAssetsType.websiteTechnologyLabel.array,
    'edit',
    AsmAssetsViewId.websiteTechnologyLabelEdit,
    () =>
      import('../components/view/asm-view-edit-website-technology-label/asm-view-edit-website-technology-label.component').then(
        m => m.AsmViewEditWebsiteTechnologyLabelComponent,
      ),
    true,
  );
  viewService.deriveView(SolType.tag.array, 'read', AsmAssetsType.hostTechnologyLabel, SolViewId.tag, {
    isDefault: true,
    mapValue: (label: string) => [SolTag.of(SolText.ofRaw(label))],
  });
  viewService.deriveView(SolType.tag.array, 'read', AsmAssetsType.domainTechnologyLabel, SolViewId.tag, {
    isDefault: true,
    mapValue: (label: string) => [SolTag.of(SolText.ofRaw(label))],
  });
  viewService.deriveView(SolType.tag.array, 'read', AsmAssetsType.websiteTechnologyLabel, SolViewId.tag, {
    isDefault: true,
    mapValue: (label: string) => [SolTag.of(SolText.ofRaw(label))],
  });
}
